import { render } from "./ResultatsAVoir.vue?vue&type=template&id=dd4943ba"
import script from "./ResultatsAVoir.vue?vue&type=script&lang=js"
export * from "./ResultatsAVoir.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__